import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './checkbox.module.css';

export interface CheckboxProps {
  checked?: boolean;
  onClick?: any;
  id: string;
  label: string;
}

export const Checkbox: FunctionComponent<CheckboxProps> = (props) => {
  const { checked, onClick, id, label } = props;

  const checkboxClassList = classNames({
    [styles.checkbox]: true,
    [styles.checked]: checked,
  });

  return (
    <div className={styles.wrapper}>
      <button type="button" id={id} className={checkboxClassList} onClick={onClick}></button>

      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};
